import { MessageCircle, Mail, Phone } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import LeadForm from "./LeadForm";
import { EMAIL, PHONE, PHONE_TEL, waLink } from "@/lib/api";
import { useLang } from "@/i18n/LangContext";

export default function ContactBlock({ source = "home-contact" }) {
  const { tr } = useLang();
  return (
    <section className="py-24 sm:py-32 relative" id="contact" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionTitle eyebrow={tr("Contact me", "Contáctame")} title={tr("What questions do you have & how can I help?", "¿Qué preguntas tienes y cómo puedo ayudarte?")} />
          <Reveal delay={0.2} className="mt-10 space-y-4">
            <p className="text-xs uppercase tracking-[0.3em] text-slate-400">{tr("Send us a message or call us now!", "¡Envíanos un mensaje o llámanos ahora!")}</p>
            <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-2xl bg-[#25D366]/10 border border-[#25D366]/30 p-5 hover:bg-[#25D366]/20 transition-colors" data-testid="contact-whatsapp-link"><MessageCircle className="text-[#25D366]" /> {tr("Message us on WhatsApp!", "¡Escríbenos por WhatsApp!")}</a>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-4 rounded-2xl bg-[#131B21] border border-[#00C9B7]/15 p-5 hover:border-[#00C9B7]/50 transition-colors" data-testid="contact-email-link"><Mail className="text-[#00C9B7]" /> {EMAIL}</a>
            <a href={PHONE_TEL} className="flex items-center gap-4 rounded-2xl bg-[#131B21] border border-[#00C9B7]/15 p-5 hover:border-[#00C9B7]/50 transition-colors" data-testid="contact-phone-link"><Phone className="text-[#00C9B7]" /> {PHONE}</a>
          </Reveal>
        </div>
        <Reveal from="right" delay={0.15} className="lg:col-span-7 rounded-3xl bg-[#131B21] border border-[#00C9B7]/15 p-6 sm:p-10">
          <LeadForm source={source} idPrefix="contact" />
        </Reveal>
      </div>
    </section>
  );
}
